import { useEffect, useState } from 'react';
import { formatTimeWithRelativeStamp } from '../utils/utilities';

const useLastSyncInterval = (lastSync: number): string => {
	const [formattedTime, setFormattedTime] = useState<string>('N/A');

	const updateLocalSync = (): void => {
		if (!lastSync) return;

		const time: string = formatTimeWithRelativeStamp(lastSync);
		setFormattedTime(time);
	};

	useEffect(() => {
		const interval = setInterval(updateLocalSync, 30000);

		return () => clearInterval(interval);
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		updateLocalSync();

		// eslint-disable-next-line
	}, [lastSync]);

	return formattedTime;
};

export default useLastSyncInterval;
